import jsPDF from 'jspdf'
import 'jspdf-autotable'

export function printSchedule (student, schedule, chosenSemester) {
	let doc = new jsPDF();

  const title = `Name: ${student.first_name} ${student.last_name}`
  const grade = `Grade: ${student.grade}`
  const semester = `Semester: ${chosenSemester}`

  const columns = [
    { title: 'Section', dataKey: 'section'},
    { title: 'Name', dataKey: 'name'},
    { title: 'Period', dataKey: 'period'},
    { title: 'Time', dataKey: 'time'},
    { title: 'Day', dataKey: 'day'},
    { title: 'Room', dataKey: 'room'},
    { title: 'Teacher', dataKey: 'teacher'},
  ]

  const columnStyles = {
   section: { columnWidth: 25 },
   name: { columnWidth: 'auto', overflow: 'linebreak' },
   period: { columnWidth: 15 },
   time: { columnWidth: 15 },
   day: { columnWidth: 15 },
   room: { columnWidth: 15 },
   teacher: { columnWidth: 30, overflow: 'linebreak' }, 
  }

  let rows = []
  schedule.m.forEach((c) => {
    let obj = {
      section: c.section,
      name: c.name,
      period: c.period,
      time: c.time,
      day: 'Mon',
      room: c.room,
      teacher: c.teacher.last_name
    }
    rows.push(obj)
  })

  schedule.t.forEach((c) => {
    let obj = {
      section: c.section,
      name: c.name,
      period: c.period,
      time: c.time,
      day: 'T/TH',
      room: c.room,
      teacher: c.teacher.last_name
    }
    rows.push(obj)
  })

  schedule.w.forEach((c) => {
      let obj = {
        section: c.section,
        name: c.name,
        period: c.period,
        time: c.time,
        day: 'Wed',
        room: c.room,
        teacher: c.teacher.last_name
      }
      rows.push(obj)
  })

  schedule.f.forEach((c) => {
      let obj = {
        section: c.section,
        name: c.name,
        period: c.period,
        time: c.time,
        day: 'Fri',
        room: c.room,
        teacher: c.teacher.last_name
      }
      rows.push(obj)
  })
  
  doc.setFontSize(12)
  doc.text(title, 10, 10)
  doc.text(grade, 10, 15)
  doc.text(semester, 10, 20)
  doc.autoTable(columns, rows, { startY: 25, columnStyles })
  doc.save('student-schedule.pdf')
}